<template>
    <div class="payFees">
        <div class="payFees_notice">
            <div class="pro-con-details">
            <div class="details-title">公证受理通知</div>
            <div class="notice_info">
                <div class="apply-contact-info">
                    <p>
                        <label>申请公证名称：</label>
                        <span>{{notarizationInfo.name}}</span>
                    </p>
                    <p>
                        <label>公证编码：</label>
                        <span>{{notarizationInfo.code}}</span>
                    </p>
                    <p>
                        <label>公证处：</label>
                        <span>{{notarizationInfo.office}}</span>
                    </p>
                    <p>
                        <label>申请人：</label>
                        <span>{{notarizationInfo.applier}}</span>
                    </p>
                    <p>
                        <label>公证事项：</label>
                        <span>{{notarizationInfo.notarizationType==1?'保全证据公证':'富强公证'}}</span>
                    </p>
                    <p>
                        <label>公证书用途：</label>
                         <span v-show="notarizationInfo.notaryCertificateUse ==1">诉讼或仲裁（仅限于民事诉讼或仲裁）</span>
                        <span v-show="notarizationInfo.notaryCertificateUse==2">非诉讼</span>
                        <span v-show="notarizationInfo.notaryCertificateUse==3">其他</span>
                    </p>
                    <p>
                        <label>公证书要求：</label>
                        <span v-show="notarizationInfo.notaryCertificateType==3 && notarizationInfo.receiptorType==1">电子公证书和纸质公证书本人领取</span>
                        <span v-show="notarizationInfo.notaryCertificateType==3 && notarizationInfo.receiptorType==2">电子公证书和纸质公证书他人领取</span>
                        <span v-show="notarizationInfo.notaryCertificateType==1">电子公证书</span>
                    </p>
                    <p>
                        <label>受理日期：</label>
                        <span>{{notarizationInfo.approvedDate?getYMH(notarizationInfo.approvedDate):''}}</span>
                    </p>
                 
                    <p>
                        <label>公证员：</label>
                        <span>{{notarizationInfo.notaryUserName}}</span>
                    </p>
                </div>
                <div class="notarization_see_box">
                    <div class="show_big_box">
                        <span class="show_big_btn" @click="showBigNotar">点击预览</span>
                    </div>
                    <div class="notarization_see">
                        <div class="notarization_pdf" :id="slgzsFIle.id"></div>
                    </div>  
                    <span>公证受理通知单</span>
                </div>
            </div>
          </div>
        </div>
        <div class="pro-con-detailss">
            <div class="details-title"><span>公证受理通知书送达回执</span></div>
            <div class="file_nav_list">
               <ul class="file_list_box">
                  <li v-for="(item,index) in fileArray" :key="index" :style="{'width':fileArray.length==1?'100%':fileArray.length==2?'50%':fileArray.length==3?'33%':'196px'}" :class="{'active_file':index==curFileind}" @click="changeFileShow(index)">{{item.templateName}}</li>
               </ul>
               <img v-if="fileArray.length>4" :class="['show_more_icon',isShowFileList?'rotateX':'rotateXs']" @click="showFileList(!isShowFileList)" src="@assets/images/judicial/bottom_icon.png"/>
            </div>
            <div class="clearboths"></div>
            <div class="file_preview">
                <div v-for="(item,index) in fileArray" :key="index" v-show="index==curFileind" :id="item.id" class="pdfCon"></div>
            </div>
        </div>
        <div class="my_seal">
            <div class="my_seal_img">
                <p>我的印章</p>
                <vue-qr v-show="!showCode" id="code_img" :text="codeUrl" ></vue-qr>
                <img  v-show="showCode" :src="handCodeUrl"/>
                <span v-show="!showCode">请打开手机上的扫一扫功能，进行手绘签名。</span>
            </div>
            <div class="operations">
                <span>请如实填写个人姓名！</span>
                <button type="button" @click="clearSign">清空签名</button>
            </div>
            <button class="sign_submit" @click="signSubmit">签署并支付公证费（¥{{payMoney}}）</button>
        </div>
        <Dialog
      :visible="isshowaction"
      :dialogTitle="'消息提示'"
      @closeDialog="hideModal"
      :width="'400px'"
    >
      <div slot="dialog">
        <div class="successFulBox">是否确认支付{{payMoney}}元公证费用?</div>
        <div class="payMoney-button">
            <button  type="button" @click="hideModal">取消</button><button type="button" @click="submitPay">确定</button>
        </div>
      </div>
    </Dialog>    
        <!-- <actions-modal v-if="isshowaction" :buttons="buttons" :msg="'是否确认支付'+payMoney+'元公证费用?'"  @handleFunc="handleFunc"></actions-modal> -->
        <div class="notarization_big_see_box" v-show="isshowBig">
            <div class="notarization_big_close" @click="closeBigNotarization">
            </div>    
            <div class="notarization_big_see">
                <div class="notarization_big_pdf" :id="slgzsFIle.id+'big'">
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>
import VueQr from "vue-qr";
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
export default {
    props:['payMoney',"notarizationInfo","user","notarizationID"],
    data(){
        return{
            //当前选项
            curFileind:0,
            //是否显示更多
            isShowFileList:false,
            //当前文件对象
            currentItem: null,
            //文件列表
            fileArray: [],
            //二维码地址 签名h5页面
            codeUrl:"",
            //是否完成手写签名
            showCode:false,
            //签名url
            handCodeUrl:"",
            //公证信息
            notarizationInfos:{

            },
            buttons:[{
              desc: '取消',
              func: 'hideModal',
            },{
              desc: '确认',
              func: 'submitPay',
            }],
            isshowaction:false,
            slgzsFIle:{},
            isshowBig:false,
        }
    },
    components:{VueQr,Dialog},
    methods:{
        //选择预览文件
        changeFileShow(index){
            this.curFileind=index;
            this.activeChange('',this.fileArray[index])
        },
        //清空签名
        clearSign(){
            this.handCodeUrl="";
            this.showCode=false;
            localStorage.removeItem('codeurl');
            this.getSignCodeUrl();
        },
        activeChange(node, item) {
            this.currentItem = (node && node.$attrs.item) || item;
            if (!this.currentItem.isAdd) {
                this.currentItem.isAdd = true;
                this.$nextTick(() => {
                this.getPdfToImage(this.currentItem.path, this.currentItem.id);
                });
            }
        },
        //关闭放大预览
        closeBigNotarization(){
            this.isshowBig=false;
        },
        //放大预览
        showBigNotar(){
            this.isshowBig=true;
            this.getPdfToImage(this.slgzsFIle.path,this.slgzsFIle.id+'big');
        },
        //显示更多
        showFileList(flag){
            if(this.fileArray.length>4){
                this.isShowFileList=flag;
                if(flag ){
                    $('.file_list_box').animate({
                        'height':Math.ceil(this.fileArray.length/4)*48 +'px'
                    },200)
                }else{
                    $('.file_list_box').animate({
                        'height':'48px'
                    },200)
                }
            }
        },
        getPage(page, index, id) {
            var scale = 1; //缩放倍数，1表示原始大小
            var viewport = page.getViewport(scale);
            var canvas = document.getElementById("canvas" + index + id);
            var canvasFather = canvas.parentNode;
            var context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            canvasFather.style.width = viewport.width + "px";
            canvasFather.style.height = viewport.height + "px";
            canvasFather.style.margin = "10px auto";
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext).promise.then(() => {
                this.loadedPageCount++;
            });
        },
        getPageNew(page, index, id) {
            var scale = 0.5; //缩放倍数，1表示原始大小
            var viewport = page.getViewport(scale);
            var canvas = document.getElementById("canvas" + index + id);
            var canvasFather = canvas.parentNode;
            var context = canvas.getContext("2d");
            canvas.height = 403;
            canvas.width = 272;
            canvasFather.style.width = 272 + "px";
            canvasFather.style.height = 403 + "px";
            // canvasFather.style.margin = "10px auto";
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            page.render(renderContext).promise.then(() => {
                this.loadedPageCount++;
            });
        },
        //加载pdf文件
        getPdfToImage(url, id) {
            var herfPash = window.location.href.split("//")[0]+"//"+window.location.href.split("//")[1].split("/")[0];
            var path =herfPash+url.substring(url.indexOf(".com") + 4);
            let container = document.getElementById(id);
            container.style.display = "block";
            let _this = this;
            url =
                path ||
                "http://xcon-dev.oss-cn-beijing.aliyuncs.com/0120190110001451/20190110/50.pdf";
            PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
                _this.totalPage = pdf.numPages;
                for (let i = 1; i <= _this.totalPage; i++) {
                $(container).append(
                    `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas></div>`
                );
                pdf.getPage(i).then(page => {
                    _this.getPage(page, i, id);
                });
                }
                $(".canvasBoxFlag").addClass("canvasBox");
                $(".pdfPageFlag").addClass("pdfPage");
            });
        },
         //加载pdf文件
        getPdfToImageNEW(url, id) {
            var herfPash = window.location.href.split("//")[0]+"//"+window.location.href.split("//")[1].split("/")[0];
            var path =herfPash+url.substring(url.indexOf(".com") + 4);
            let container = document.getElementById(id);
            container.style.display = "block";
            let _this = this;
            url =
                path ||
                "http://xcon-dev.oss-cn-beijing.aliyuncs.com/0120190110001451/20190110/50.pdf";
            PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
                _this.totalPage = pdf.numPages;
                for (let i = 1; i <= _this.totalPage; i++) {
                $(container).append(
                    `<div class="canvasBoxFlag" data-pageIndex=${i} id="canvasBoxFlag${i}${id}"><canvas data-pageIndex=${i} class="canvasContent" id="canvas${i}${id}"></canvas></div>`
                );
                pdf.getPage(i).then(page => {
                    _this.getPageNew(page, i, id);
                });
                }
                $(".canvasBoxFlag").addClass("canvasBox");
                $(".pdfPageFlag").addClass("pdfPage");
            });
        },
        //提交
        submitPay(){
            let str=this.fileArray.map((item)=>{
               return item.id;
            })
            if(str.length){
                 this.$emit('signPayFeesSubmit',{
                    id:this.notarizationInfo.id,//公证id
                    uuid:this.notarizationInfo.id,//签名传递的uuid
                    uid:this.user.currentUserId,
                    loginAccount:this.user.loginAccount,
                    notaryFiles:str.join(",")//签约文件id
                })
                 this.isshowaction=false;
            }
        },
        hideModal(){
             this.isshowaction=false;
        },
        handleFunc(func) {
            if (this[func] && typeof this[func] == "function") {
                this[func]();
            }
        },
        getAdd(time){
            if(time>9){
            return time
            }else{
            return "0"+time
            }
        },
        getYMH(dateTime){
            let newDateTime=new Date(dateTime);
            return newDateTime.getFullYear() + "-"+ this.getAdd(newDateTime.getMonth() + 1) +"-"+ this.getAdd(newDateTime.getDate()) +" "+this.getAdd(newDateTime.getHours())+":"+this.getAdd(newDateTime.getMinutes())+":"+this.getAdd(newDateTime.getSeconds());
        },
        //提交
        signSubmit(){
            if( this.handCodeUrl){
                this.isshowaction=true;
            }else{
                this.$store.dispatch("showMsgModal", {
                    autoClose: true,
                    info: "请上传手写签名"
                });
            }
        },
        //轮询获取手写签名
        getSignCodeUrl(){
            BaseApi.createRpcToken("/judicial/gdgz/getFileSingOssUrl",{
                uuid: this.notarizationInfo.id+"_1"
            }, "POST").then(response => {
            this.outTimer = setTimeout(() => {
                    if(!localStorage.getItem('codeurl')){
                        localStorage.setItem('codeurl',response.data.url?response.data.url.split("?")[0]:"false")
                    }
                    if(response.data.url){
                        if(response.data.url.split("?")[0]==localStorage.getItem('codeurl')){
                            this.getSignCodeUrl();
                        }else{
                            this.handCodeUrl=response.data.url;
                            this.showCode=true;
                            clearTimeout(this.outTimer)
                        }
                    }else{
                        this.getSignCodeUrl();
                    }
                }, 1000)  
            })
        },
          getNotaryFile(){
           BaseApi.createRpcToken("/judicial/gdgz/getNotaryFile",{
                applyDataId: this.notarizationID
            }, "POST").then(res=>{
                if(res.data.code==200){
                    if(res.data.data.length){
                        this.fileArray=res.data.data.filter(item=>item.code!="DZZJBQGZ_SLTZD");
                        if(this.fileArray.length){
                            this.activeChange('',this.fileArray[0]);
                        }   
                    }
                }
            })
        },
         getNotarySignFile(){
           BaseApi.createRpcToken("/judicial/gdgz/getNotarySignFile",{
                applyDataId: this.notarizationID
            }, "POST").then(res=>{
                if(res.data.code==200){
                    if(res.data.data.length){
                         // this.fileArray=res.data.data.filter(item=>item.code!="DZZJBQGZ_SLTZD");
                        this.slgzsFIle=res.data.data.filter(item=>item.code=="DZZJBQGZ_SLTZD")[0];
                        // if(this.fileArray.length){
                        //     this.activeChange('',this.fileArray[0]);
                            this.$nextTick(() => {
                                this.getPdfToImageNEW(this.slgzsFIle.path,this.slgzsFIle.id)
                            })
                        // }   
                    }
                }
            })
        }
    },
    created(){
        this.codeUrl=window.location.origin +"/m/canvasSign-notarization?notarizationID="+this.notarizationID+"&token="+this.user.currentUserId+"&signtype=2";
    },
    mounted(){
        localStorage.removeItem('codeurl');
        this.getNotaryFile();
        this.getNotarySignFile();
        this.getSignCodeUrl();
    }
}
</script>
<style scoped lang="scss">
.payFees{
    width: 100%;
    height: 100%;
}
.pro-con-detailss {
  margin: 0 auto;
//   border: 1px solid #e4e4e4;
  /*border-radius: 4px;*/
//   background-color: #f9f9f9;
  color: #464646;
  position: relative;
  
}
.details-title {
    display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: 46px;
  padding: 0 15px;
  border: 1px solid #e4e4e4;
//   border-bottom: 1px solid #e4e4e4;
  background: url(../../../../../assets/images/judicial/arrow.png) no-repeat #f9f9f9;
  background-position: 15px 19px;
  padding-left: 32px;
  span:nth-child(2){
    font-size: 14px;
    font-weight: 500;
    color: #A0A0A0;
  }
}
.notarization_big_see_box{
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba($color:#000, $alpha: .5);
    z-index: 99999;
    .notarization_big_close{
        position: absolute;
        left: 80.8%;
        transform: translate(-50%, 5%);
        top: 2.5%;
        z-index: 999999;
        cursor: pointer;
        width: 25px;
        height: 25px;
        background: url("../../../../../assets/images/judicial/close_big.png") no-repeat;
        background-size: 100% 100%;
    } 
    .notarization_big_close:hover{
        background: url("../../../../../assets/images/judicial/close_big_pre.png") no-repeat;
        background-size: 100% 100%;
    } 
    .notarization_big_see{
        position: fixed;
        overflow: auto;
        left: 50%;
        transform: translate(-50%, 5%);
        top: 10px;
        width: 60%;
        height: 90%;
        background-color: #fff;
        z-index: 9999;
         
        .notarization_big_pdf{
            width: 100%;
            height: 100%;
        }
    }
}
.payFees_notice{
    width: 100%;
    .notice_info{
        width: 100%;
        display: flex;
        justify-content: space-around;
        background: #F9F9F9;
        margin-bottom: 21px;
        padding-top: 25px ;
        .notarization_see_box{
            position: relative;
            span{
                display: block;
                margin: 0 auto;
                font-size: 14px;
                color: #646464;
                margin-top: 10px;
                text-align: center;
                margin-bottom: 10px;
            }
            .show_big_box{
                width: 100%;
                height: 425px;
                position: absolute;
                top: 0px;
                left: 0px;
                z-index: 9999;
                background: rgba($color: #000000, $alpha: 0.2);
                display:none;
                text-align: center;
                line-height: 425px;
            }
            .show_big_btn{
                color: #ffffff;
                font-size: 16px;
                cursor: pointer;
                z-index: 9999;
            }
        }
        .notarization_see{
            width: 294px;
            height: 425px;
            background: #ECECEC;
            padding: 11px;
            box-sizing: border-box;
            position: relative;
            
            .notarization_pdf{
              width: 100%;
              height: 100%;
              overflow: hidden;
            }
        }
        .notarization_see_box:hover .show_big_box{
            display: block;
        }
        .apply-contact-info{
            width: 393px;
            p {
                height: 34px;
                line-height: 34px;
                margin-top: 8px;
            }
            label {
                display: inline-block;
                /*text-align:justify;
                    text-align-last: justify;*/
                text-align: right;
                width: 136px;
                margin-right: 15px;
                float: left;
            }
            input {
                height: 32px;
                width: 310px;
                border: 1px solid #e4e4e4;
                float: left;
                padding-left: 8px;
            }
        }
    }
}
.file_nav_list{
    width: 100%;
    position: absolute;
    top: 46px;
    z-index: 9;
    ul {
        width: 100%;
        height:48px;
        overflow: hidden; 
        border: 1px solid #E4E8EB;
        border-top: 0px;
        background: #F7F7F7;
        li{
            width: 196px;
            height: 48px;
            border-bottom: 1px solid #E4E8EB;
            font-size: 12px;
            font-weight: 400;
            color: #646464;
            line-height: 48px;
            float: left;
            text-align: center;
            border-right: 1px solid #E4E8EB;
            cursor: pointer;
            box-sizing: border-box;
        }
        li:hover{
            background: rgb(236, 236, 236);
            color: #616161 !important;
        }
        .active_file{
            background: #FFFFFF;
            font-weight: 600;
            color: #CE130E;
        }
    }
    .show_more_icon{
        width: 48px;
        position: absolute;
        top: 0px;
        height: 48px;
        right: 0px;
        cursor: pointer;
    }
    .rotateX{
            transform: rotateX(180deg);
            transition:.5s;
    }
    .rotateXs{
            transform: rotateX(0deg);
            transition:.5s;
    }
}
.clearboths{
    height: 48px;
}
.file_preview{
    height: 564px;
    overflow-y:auto;
    overflow: hidden;
    background: #E2E2E2;
    .pdfCon {
          box-sizing: border-box;
          height: calc(100% - 10px);
          margin: 0 auto;
          margin-top: 10px;
          overflow: auto;
        }
}
.my_seal{
    width: 830px;
    margin: 0 auto;
    padding-bottom: 50px;
    .my_seal_img{
        text-align: center;
        width: 100%;
        height: 295px;
        background: #FFFFFF;
        border: 1px solid #E4DFDF;
        margin-top: 20px;
        p{
            width: 100%;
            text-align: left;
            padding: 20px 0px 0px 20px;
            font-size: 18px;
            color: #646464;
        }
        img{
            width: 120px;
            height: 120px;
            margin: 0 auto;
            margin-top: 15px;
        }
        span{
            font-size: 14px;
            color: #646464;
            display: block;
            text-align: center;
            width: 100%;
        }
    }
    .operations{
        width: 100%;
        height: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0px 20px 0px;
        span{
            font-size: 13px;
            color: #B4B4B4;
        }
        button{
            width: 105px;
            height: 38px;
            background: #FFFFFF;
            border-radius: 19px;
            border: 1px solid #CE130E;
            font-size: 16px;
            color: #CE130E;
        }
    }
    .sign_submit{
        width: 240px;
        height: 44px;
       background: #f5f5f5;
        border: 1px solid #e4e4e4;
        font-size: 16px;
        color: #464646;
        display: block;
        margin: 0 auto;
    }
    .sign_submit:hover{
        background: #D81212;
        border: 1px solid #D81212;
        font-size: 16px;
        color: #ffffff;
    }
}
.payMoney-button{
    padding: 20px 0px;
    width: 100%;
    text-align: center;
    button{
       width: 100px;
        height: 32px;
       background: #f5f5f5;
        border: 1px solid #e4e4e4;
        font-size: 13px;
        color: #464646;
        cursor: pointer;
        
    }
    button:nth-child(1){
        margin-right: 20px;
    }
    button:hover{
        background: #D81212;
        border: 1px solid #D81212;
        font-size: 13px;
        color: #ffffff;
    }
}

    .successFulBox{
       text-align: center;
       margin: 30px 0px 20px 0px;
    }
</style>